/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Compare_Note_CapsInputs */

const en_why_listening_compare_note_caps = /** @type {(inputs: Why_Listening_Compare_Note_CapsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Word or hour caps`)
};

const es_why_listening_compare_note_caps = /** @type {(inputs: Why_Listening_Compare_Note_CapsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Límites de palabras u horas`)
};

/**
* | output |
* | --- |
* | "Word or hour caps" |
*
* @param {Why_Listening_Compare_Note_CapsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_compare_note_caps = /** @type {((inputs?: Why_Listening_Compare_Note_CapsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Compare_Note_CapsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_compare_note_caps(inputs)
	return en_why_listening_compare_note_caps(inputs)
});